
export { default as PriceDetails } from "./Organisms/PriceDetails"